module.exports = __webpack_public_path__ + "media/images/landkit/icons/social/linkedin-0873046c22fc48321ae9b305a5c9e61a.svg";